import React from 'react';
import useStyles from '../ServiceWarrantyPage.styles';
import {Button, Typography} from '@material-ui/core';
import Faq from 'components/Faq';
import Content from 'components/Content';
import {Link} from 'react-navi';

export default function () {
    let classes = useStyles();

    return (
        <>
            <Faq
                title="Ik heb een klacht"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Klachten vinden we nooit leuk! We doen er dan ook alles aan om je klacht zo goed mogelijk op te lossen en van jou
                        weer een tevreden klant te maken. Je kunt je klacht bij ons per e-mail of telefonisch kenbaar maken.
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        component={Link}
                        href="/contact/"
                    >
                        Contact opnemen
                    </Button>
                </Content>
            </Faq>
            <Faq
                title="Hoe lang geven jullie ondersteuning op het geleverde werk?"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Na oplevering van je project geven we nog 3 maanden gratis ondersteuning. Dit betekend dat je in die periode nog
                        wijzigingen aan ons kunt doorgeven. Wij zullen deze kostenloos voor je oppakken.
                    </Typography>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Als de 3 maanden voorbij zijn kunnen we je uiteraard nog steeds helpen met je project. Neem dan contact met ons op
                        om je wensen te bespreken. Wij zullen je hier dan een passende offerte voor doen toekomen.
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        component={Link}
                        href="/contact/"
                    >
                        Contact opnemen
                    </Button>
                </Content>
            </Faq>
            <Faq
                title="Hoe geef ik wijzigingen aan jullie door?"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Via onze speciaal ontwikkelde preview omgeving kun je eenvoudig je project bekijken en wijzigingen aan ons
                        doorgeven. Wij zullen je wijzigingen z.s.m. oppakken of wanneer er onduidelijkheid over je wijziging is sturen
                        we je een e-mail met de vraag om je wijziging op te helderen.
                    </Typography>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Je kunt de preview omgeving openen door in het klantenpaneel bij je project op de "<strong>Bekijken</strong>"
                        button te klikken.
                    </Typography>
                </Content>
            </Faq>
        </>
    );
};
